import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useGoogleAnalytics = () => {
    const location = useLocation();

    useEffect(() => {
        const sendPageView = () => {
            if (typeof window !== 'undefined' && typeof gtag === 'function') {
                gtag('config', 'G-41609N9MEY', {
                    page_path: location.pathname + location.search,
                    page_location: window.location.href,
                });

                gtag('event', 'page_view', {
                    page_title: document.title,
                    page_location: window.location.href,
                    page_path: location.pathname + location.search,
                });
            }
        };

        const timeoutId = setTimeout(sendPageView, 100);

        return () => clearTimeout(timeoutId);
    }, [location]);
};
